module.exports = __webpack_public_path__ + "static/media/naka-itabashi-7.c7a1ced4.jpg";